<template>
  <b-modal :active.sync="isModalActive" @after-leave="hide()" scroll="keep" :can-cancel="canCancel">
    <div class="bg-white border rounded shadow-lg border-blue-light">

      <header class="modal-card-head">
        <p class="modal-card-title">Configurar Flujos de validación</p>
      </header>

      <section class="modal-card-body">
        <b-collapse
          class="card"
          animation="slide"
          v-if="!isLoading"
          v-for="(item, index) of data"
          :key="index"
          :open="isOpen == index"
          @open="isOpen = index"
          :aria-id="'contentIdForA11y5-' + index">
          <template #trigger="props">
              <div
                class="card-header"
                role="button"
                :aria-controls="'contentIdForA11y5-' + index"
                :aria-expanded="props.open"
                :style="item.taskSelected ? 'background: #cec': 'background: #ecc'"
              >
                  <p class="card-header-title">
                      {{ item.template.name }}
                  </p>
                  <a class="card-header-icon">
                      <b-icon pack="fa" :icon="props.open ? 'caret-down' : 'caret-up'">
                      </b-icon>
                  </a>
              </div>
          </template>
          <div class="card-content">
              <div class="content">
                <div class="flex flex-col">
                  <b-field label="Selecciona tarea"></b-field>
                    <treeselect 
                        v-model="item.taskSelected" 
                        :close-on-select="true" 
                        :required="true"
                        :options="item.tasks" 
                    />
                </div>
              </div>
          </div>
        </b-collapse>

        <scale-loader v-if="isLoading"/>
      </section>
      
      <div class="px-4 pb-4">
        <button class="button is-success" v-on:click="hide()">{{ $t('save') }}</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Vue from 'vue';
import axios from "axios";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    ScaleLoader,
    Treeselect
  },

  data: () => ({
    isModalActive: false,
    canCancel: ['escape', 'x', 'outside'],
    isOpen: null,
    isLoading: false, 
    data: []
  }),

  methods: {
    async show(templates) {
      this.isModalActive = true;
      this.isLoading = true;
      this.isOpen = null;
      if (this.data.length) {
        this.isLoading = false
        return
      }
      for (let template of templates) {
        let {data} = await axios.get('/api/v2/validations/template/' + template.id)
        if (data.data && data.success) {
          this.data.push({
            template,
            taskSelected: null,
            tasks: data.data.tasks.map(task => {
              return {
                id: task.code,
                label: task.name,
                children: task.children.map(child => {
                  return {
                    id: child.code,
                    label: child.name
                  }
                })
              }
            })
          })
        }
      }
      this.isLoading = false;
    },

    hide() {
      this.canCancel = ['escape', 'x', 'outside']
      this.isModalActive = false;
    }
  },
};
</script>
